// extracted by mini-css-extract-plugin
export default {"card":"ArcadeLand_card__89aFm","landSizes":"ArcadeLand_landSizes__+njcx","list":"ArcadeLand_list__uoDeZ"};